import React from "react";
import moment from "moment";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Select, DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/en_US";

const { RangePicker } = DatePicker;
const { Option } = Select;

class FormFive extends React.Component {
  range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  disabledDate = (current) => {
    return current && current < moment().endOf("day");
  };

  disabledRangeTime = (_, type) => {
    if (type === "start") {
      return {
        disabledHours: () => this.range(0, 60).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
      };
    }
    return {
      disabledHours: () => this.range(0, 60).splice(20, 4),
      disabledMinutes: () => this.range(0, 31),
      disabledSeconds: () => [55, 56],
    };
  };

  render() {
    const { onSubmit, form, signersGroupsGetData } = this.props;
    const { getFieldDecorator, getFieldValue } = form;

    const hotelOptions = signersGroupsGetData.users.map((d) => (
      <Option
        key={d._id}
        disabled={
          d.email && getFieldValue("out_of_office_assignee") !== d._id
            ? false
            : true
        }
      >
        {d.name} - {d.user_name} - {d.email ? d.email : <b>No user email</b>}
      </Option>
    ));

    const outOfOfficeAllUsersOptions =
      signersGroupsGetData.out_of_office_all_users.map((d) => (
        <Option
          key={d._id}
          disabled={
            d.email && getFieldValue("out_of_office_assigner") !== d._id
              ? null
              : true
          }
        >
          {d.name} - {d.user_name} - {d.email ? d.email : <b>No user email</b>}
        </Option>
      ));

    // function disabledDate(current) {
    //   // Can not select days before today and today
    //   return current && current < moment().endOf('day');
    // }

    return (
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        onSubmit={onSubmit}
      >
        <Form.Item label="Assigner">
          {getFieldDecorator("out_of_office_assigner", {
            rules: [
              {
                required: true,
                message: "Please select assigner!",
              },
            ],
          })(
            <Select
              showSearch
              placeholder="Select Assigner"
              optionFilterProp="children"
              notFoundContent={null}
            >
              {hotelOptions}
            </Select>
          )}
        </Form.Item>

        <Form.Item label="Assignee">
          {getFieldDecorator("out_of_office_assignee", {
            rules: [
              {
                required: true,
                message: "Please select assignee!",
              },
            ],
          })(
            <Select
              showSearch
              placeholder="Select Assignee"
              optionFilterProp="children"
              notFoundContent={null}
            >
              {outOfOfficeAllUsersOptions}
            </Select>
          )}
        </Form.Item>

        <Form.Item label="Duration">
          {getFieldDecorator("out_of_office_duration", {
            rules: [
              {
                required: true,
                message: "Please select duration!",
              },
            ],
          })(
            <RangePicker
              // locale={locale}
              showTime={{ format: "HH:mm" }}
              format="YYYY-MM-DD HH:mm"
              disabledDate={this.disabledDate}
              //  disabledTime={this.disabledRangeTime}
              style={{ width: "100%" }}
            />
          )}
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
          <Button type="primary" htmlType="submit">
            Create
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const WrappedApp = Form.create({ name: "form_five" })(FormFive);

export default WrappedApp;
